import Schema from "nexia_mobile/models/schema";

export default {
  parseLinksDetails(links) {
    let link = _.first(links);

    if (link) {
      let SchemaClass = this.getDetailsSchemaClass();
      let schema = new SchemaClass(link.getData(), { parse: true });
      schema.parentModel = this; // so the details schema can be used to delete its parent resource
      schema.setUrl(link.href);
      schema.setStoredOnServer(link.isPostLink());
      this._detailsSchema = schema;
    }
  },

  createDetailsSchema() {
    if (this._detailsSchema) {
      return this._detailsSchema.prepare();
    } else {
      return Promise.reject(
        new Error(
          "Attempted to create a details schema for a model that had no details link"
        )
      );
    }
  },

  getDetailsSchemaClass() {
    return Schema;
  },
};



// WEBPACK FOOTER //
// ./src/models/mixins/detailsable.js